import axiosInstance from "./axiosInstance";

export const obtenerMembresia = async (date, idTitular = null) => {
    let params = { currentDate: encodeURIComponent(date) }
    params['idTitular'] = idTitular ? encodeURIComponent(idTitular) : null;
    return await axiosInstance.get(
        //`${process.env.REACT_APP_BASE_URL}/obtener-membresia?currentDate=${date}`,
        `${process.env.REACT_APP_BASE_URL}/obtener-membresia`,
        { 
            params: params,
            withCredentials: true 
        }
    );
}

export const obtenerMisFinanzas = async (quarter, year, idTitular = null) => {
    let params = { quarter, year }
    params['idTitular'] = idTitular ? encodeURIComponent(idTitular) : null;
    return await axiosInstance.get(
        //`${process.env.REACT_APP_BASE_URL}/mis-finanzas?quarter=${quarter}&year=${year}`,
        `${process.env.REACT_APP_BASE_URL}/mis-finanzas`,
        {
            params: params,
            withCredentials: true 
        }
    );
}